const languages = [{ label: 'English', value: 'en' }, { label: 'Français', value: 'fr' }];

export default languages;
